export type FailedSearch = {
  reason?: "timeout";
};

export const parseFailedSearch = (
  search: Record<string, unknown>,
): FailedSearch => ({
  reason: search.reason === "timeout" ? "timeout" : undefined,
});
